// MUI
import { Box, CircularProgress, Typography } from '@mui/material'

// Assets
import { MedGEOLogoComponent } from 'assets/MedGEOlogo'

// Other
import { Helmet } from 'react-helmet'

// Types
import { LoadingStateProps } from './types'

// Styles
import '../GuestAccess.scss'

const LoadingState = ({
  title = 'Getting Updated Surgery Info',
  message = 'Please wait while we update your information...',
}: LoadingStateProps) => {
  return (
    <div className="guest-access-page">
      <Helmet>
        <title>Updating Surgery Info</title>
      </Helmet>

      <div className="auth0-card">
        <div className="logo-container">
          <MedGEOLogoComponent scale={1.2} />
        </div>

        <div className="auth0-title">{title}</div>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mt: 4,
          }}
        >
          <CircularProgress size={40} />
          <Typography variant="body1" sx={{ mt: 4, textAlign: 'center' }}>
            {message}
          </Typography>
        </Box>
      </div>
    </div>
  )
}

export default LoadingState
